import React from 'react';
import { motion } from 'framer-motion';
import { SPRING_CONFIG, HOVER_SCALE, PRESS_SCALE } from '../../utils/constants';

// Enhanced Premium Button Component
const PremiumButton = ({ 
  children, onClick, disabled, variant = "primary", size = "md", 
  className = "", icon, loading = false, pulse = false 
}) => {
  const variants = {
    primary: `bg-gradient-to-r from-[#15FF75] via-[#1AE885] to-[#15FF75] text-[#0A0E1B] font-bold 
      shadow-[0_8px_32px_rgba(21,255,117,0.35)] hover:shadow-[0_12px_40px_rgba(21,255,117,0.5)]
      hover:from-[#1AE885] hover:to-[#1AE885] transform-gpu`,
    secondary: `bg-gradient-to-r from-[#1A2235] to-[#1F2940] text-[#15FF75] border border-[#15FF75]/25 
      hover:border-[#15FF75]/50 hover:shadow-[0_8px_32px_rgba(21,255,117,0.2)] transform-gpu`,
    ghost: `bg-transparent text-[#8AA5A2] hover:text-[#15FF75] hover:bg-[#15FF75]/[0.08] 
      border border-transparent hover:border-[#15FF75]/25 transform-gpu`,
    danger: `bg-gradient-to-r from-[#FF4747] to-[#FF6B6B] text-white font-bold 
      shadow-[0_8px_32px_rgba(255,71,71,0.35)] hover:shadow-[0_12px_40px_rgba(255,71,71,0.5)]
      hover:from-[#FF6B6B] hover:to-[#FF6B6B] transform-gpu`
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg"
  };

  return (
    <motion.button
      onClick={onClick}
      disabled={disabled || loading}
      className={`relative flex items-center justify-center gap-2 rounded-2xl font-medium
        transition-all duration-500 ${variants[variant]} ${sizes[size]} ${className}
        ${disabled || loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${pulse && !disabled ? 'animate-pulse' : ''}`}
      whileHover={disabled || loading ? {} : { scale: HOVER_SCALE }}
      whileTap={disabled || loading ? {} : { scale: PRESS_SCALE }}
      transition={SPRING_CONFIG}
    >
      {variant === "primary" && !disabled && (
        <motion.div
          className="absolute inset-0 rounded-2xl bg-gradient-to-r from-transparent via-white/20 to-transparent"
          animate={{ x: [-200, 200] }}
          transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
          style={{ clipPath: "inset(0)" }}
        />
      )}
      
      <span className="relative z-10 flex items-center gap-2">
        {loading && <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />}
        {!loading && icon && <span className="w-5 h-5">{icon}</span>}
        {children}
      </span>
    </motion.button>
  );
};

export default PremiumButton;